import $ from 'jquery';
export class ColorBoundary {
    constructor() {
        this._label = "";
        this._color = "#000000";
        this._count = 0;
        this.visible = true;
        this.label_element = $(`<div class="category" data-name="${this.label}"></div>`);
        this.label_element.text(`${this.label} (${this.count})`);
        this.color_element = $(`<div class="color" style="background-color: ${this.color};"></div>`);
        this.label_element.prepend(this.color_element);
    }
    get label() { return this._label; }
    set label(value) {
        this._label = value;
        this.label_element.attr('data-name', this._label);
        this.label_element.text(`${this._label} (${this.count})`);
    }
    get count() { return this._count; }
    set count(num) {
        this._count = num;
        this.label_element.text(`${this.label} (${this._count})`);
        this.label_element.prepend(this.color_element);
    }
    get color() { return this._color; }
    set color(val) {
        this._color = val;
        this.color_element.css(`background-color`, val);
    }
    static from(v) {
        const ret = new ColorBoundary();
        ret.label = v.label;
        ret.color = v.color;
        ret.count = v.count;
        return ret;
    }
}
